import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import messages from './local/index';

// Detect browser language: use 'zh' if Chinese, otherwise 'en'
const browserLang = navigator.language || '';
const defaultLang = browserLang.toLowerCase().startsWith('zh') ? 'zh' : 'en';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: defaultLang,
    fallbackLng: 'en',
    debug: false,
    resources: messages,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: [],
      caches: [],
    },
  });

export default i18n;